/**
 * App Body File.
 *
 * created by Ty DeMarcus Kennedy 10/4/2022
 */
import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Row, Container, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { getCookie, setCookie } from "../utils/cookies";
import { decodeJWTBearer } from "../utils/decodeJWT";

const LoginComp = () => {
  const [email, setEmail] = useState("ea_1_aassistance@yahoo.com");
  const [password, setPassword] = useState("123abc");

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const req = await axios("https://ea1-dev.azurewebsites.net/login", {
        method: "POST",
        data: {
          email,
          password,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log(`User Data:`);
      console.log(req.data);
      console.log("headers.authorization");
      console.log(req.headers);

      if (
        req.headers.authorization &&
        decodeJWTBearer(req.headers.authorization)
      ) {
        const JWT = req.headers.authorization;
        console.log(`JWT`);
        console.log(JWT);
        setCookie("ea1-auth", JWT);
        setIsLoading(false);
        navigate("/dashboard");
      } else {
        alert("login Error");
        return;
      }
    } catch (e) {
      console.log(e);
      alert("login error");
    }
  };

  const checkAuthCookie = async () => {
    const JWT = await getCookie("ea1-auth");
    console.log("checking auth cookie");
    console.log(`JWT`);
    console.log(JWT);
    console.log(`JWT Data`);
    console.log(decodeJWTBearer(JWT));

    if (decodeJWTBearer(JWT)) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        navigate("/dashboard");
      }, 1000);
    }
  };

  useEffect(() => {
    checkAuthCookie();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LoginForm = (
    <Form
      style={{
        backgroundColor: "#eee",
        padding: 20,
        borderRadius: 15,
        boxShadow: "-3px 10px 15px 0px rgb(0 0 0 / 75%)",
      }}
    >
      <div>
        <h4>Emergency Assistance Admin Portal</h4>
      </div>
      <Form.Group className='mb-3' controlId='formBasicEmail'>
        <Form.Label>Email address</Form.Label>
        <Form.Control
          type='email'
          placeholder='Enter email'
          defaultValue={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </Form.Group>

      <Form.Group className='mb-3' controlId='formBasicPassword'>
        <Form.Label>Password</Form.Label>
        <Form.Control
          type='password'
          placeholder='Password'
          defaultValue={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <Form.Text className='text-muted'>
          If you need an account, please contact{" "}
          <a href='mailto:admin.support@ecare-software.com'>
            admin.support@ecare-software.com
          </a>
        </Form.Text>
      </Form.Group>
      <Form.Group className='mb-3 text-right' controlId='formSubmit'>
        <Button variant='dark' onClick={handleSubmit}>
          Submit
        </Button>
      </Form.Group>
    </Form>
  );
  return (
    <Container>
      <Row>
        {isLoading ? (
          <div
            className='d-flex justify-content-center align-items-center'
            id='basicLoader'
            style={{ marginTop: "40%" }}
          >
            <h2 className='text-center'>Loading</h2>
            <div className='ml-3'>
              <div className='ml-3 spinner-grow text-danger'></div>
              <div className='ml-3 spinner-grow text-warning'></div>
              <div className='ml-3 spinner-grow text-success'></div>
            </div>
          </div>
        ) : (
          <>
            <Col lg='6'>{LoginForm}</Col>
          </>
        )}
      </Row>
    </Container>
  );
};

export default function Home() {
  return (
    <div
      style={{
        height: "100vh",
        backgroundImage: `url(${process.env.PUBLIC_URL + "/road.jpg"})`,
        backgroundPosition: "center",
      }}
      className='d-flex justify-content-center align-items-center'
    >
      <LoginComp />
    </div>
  );
}
